import React, { useEffect, useRef } from 'react';
import './TaskManager.css';

const TaskManager = ({ windows, onClose, onCloseAll }) => {
  const taskManagerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (taskManagerRef.current && !taskManagerRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener after a short delay to prevent immediate close
    const timer = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 100);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="task-manager" ref={taskManagerRef}>
      <div className="task-manager-header">
        <h3>Task Manager</h3>
        <button className="task-manager-close" onClick={onClose}>✕</button>
      </div>
      <div className="task-manager-content">
        {windows.length === 0 ? (
          <div className="no-tasks">
            <p>No open windows</p>
          </div>
        ) : (
          <>
            <div className="task-list">
              {windows.map((window) => (
                <div key={window.id} className="task-item">
                  <img src={window.icon} alt="" className="task-icon" />
                  <span className="task-title">{window.title}</span>
                </div>
              ))}
            </div>
            <div className="task-manager-footer">
              <button className="kill-all-btn" onClick={onCloseAll}>
                Kill All
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TaskManager;
